import omitBy from 'lodash/omitBy'
import isNil from 'lodash/isNil'
import merge from 'lodash/merge'
import Vue from 'vue'
import Ncs from 'ncs'
import config from '../search/ncs_config'
import KwicHeader from './KwicHeader'
import ContextHeader from './ContextHeader'
import ContextTextTitle from './ContextTextTitle'


const components = {
  ...Ncs.defaultComponents,
  NcsKwicResultHeader: KwicHeader,
  NcsContextDocumentHeader: ContextHeader,
  NcsContextTextTitle: ContextTextTitle,
}

function csvElementFields(document, text, elements, matches) {
  return omitBy({
    [this.$i18n.t('result.context.header.document.student')]: document.student,
    [this.$i18n.t('result.context.header.document.course')]: document.course,
    [this.$i18n.t('result.context.header.document.level')]: document.level,
    [this.$i18n.t('result.context.header.document.age')]: document.age,
    [this.$i18n.t('result.context.header.document.sex')]: document.sex,
    [this.$i18n.t('result.context.header.document.parents_origin')]: document.parents_origin.join(' | '),
    [this.$i18n.t('result.context.header.document.place_of_birth')]: document.place_of_birth,
    [this.$i18n.t('result.context.header.document.mother_tongue')]: document.mother_tongue,
    [this.$i18n.t('result.context.header.document.age_studying_was_started')]: document.age_studying_was_started,
    [this.$i18n.t('result.context.header.document.months_abroad')]: document.months_abroad,
    [this.$i18n.t('result.context.header.document.contacts')]: document.contacts,
    [this.$i18n.t('result.context.header.document.date')]: document.date,
    [this.$i18n.t('result.context.header.document.studies')]: document.studies,
    [this.$i18n.t('result.context.header.document.topic')]: document.topic,
    [this.$i18n.t('result.context.header.document.text_type')]: document.text_type,
    [this.$i18n.t('result.context.header.document.task_type')]: document.task_type,
    [this.$i18n.t('result.context.header.document.other_languages')]: document.other_languages.join(' | ')
  }, v => v === '' || isNil(v))
}

Vue.use(Ncs, {config: merge(gon.config, config), components, csvElementFields})

export {Vue, Ncs}
